// 出入库记录
import { axiosPost } from "@/utils/request";

/**
 * 查询出入库记录明细
 * @param {*} params
 * @returns
 */
export const selectOutInRecordsDetail = (params) => {
    return axiosPost({
      url: "/outInputRecords/selectOutInRecordsDetail",
      data: params,
    });
  };
/**
 * 查询出入库记录
 * @param {*} params
 * @returns
 */
export const selectOutInputRecords = (params) => {
    return axiosPost({
      url: "/outInputRecords/selectOutInputRecords",
      data: params,
    });
  };
/**
 * 根据产品出入库记录id查询产品
 * @param {*} params
 * @returns
 */
export const selectProductInventoryByProductRecordsId = (params) => {
    return axiosPost({
      url: "/outInputRecords/selectProductInventoryByProductRecordsId",
      data: params,
    });
  };
/**
 * 根据申请单id查询关联的产品
 * @param {*} params
 * @returns
 */
export const selectProductRecordsByApplicationFormId = (params) => {
    return axiosPost({
      url: "/outInputRecords/selectProductRecordsByApplicationFormId",
      data: params,
    });
  };
/**
 * 根据出入库记录id查询关联的产品
 * @param {*} params
 * @returns
 */
export const selectProductRecordsByOutInRecordsId = (params) => {
    return axiosPost({
      url: "/outInputRecords/selectProductRecordsByOutInRecordsId",
      data: {outInRecordsId:params},
    });
  };
/**
 * 查询产品出入库明细
 * @param {*} params
 * @returns
 */
export const selectProductOutInRecordDetail = (params) => {
    return axiosPost({
      url: "/outInputRecords/selectProductOutInRecordDetail",
      data: params,
    });
  };
/**
 * 查询出库总量，入库总量，实时库存
 * @param {*} params
 * @returns
 */
export const selectOutAndInAndRealInventoryTotal = (params) => {
    return axiosPost({
      url: "/outInputRecords/selectOutAndInAndRealInventoryTotal",
      data: params,
    });
  };